// extracted by mini-css-extract-plugin
export default {"header":"_3jNtFAWh","nav-button":"XtsN5yB1","navButton":"XtsN5yB1","disabled":"_3U4K4aNw"};